var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flashcard',{attrs:{"front":"TRACKERSTACKER INVENTORY SYSTEM (SWIFT)","back":"iPhone application that can be used by any type of business or even for personal use.\n        User will be able to add and remove categories and data for the items.","headerFront":"","headerBack":"","footerFront":"","footerBack":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b4a756","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackerStacker.vue
// module id = null
// module chunks = 